<h2 mat-dialog-title class="tw-m-0 tw-text-lg tw-font-semibold">{{ data.title }}</h2>
<div
  appGlossScroll
  mat-dialog-content
  class="tw-max-h-[70vh] tw-overflow-y-auto tw-min-w-[min(90vw,36rem)]"
>
  <div class="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-2 tw-mb-2">
    <span class="tw-text-xs tw-font-mono tw-text-dt-text-secondary">
      id: {{ data.item.id }} · vid: {{ data.item.vid ?? "—" }}
    </span>
    <button type="button" mat-stroked-button class="tw-text-xs tw-shrink-0" (click)="copy()">
      Copy JSON
    </button>
  </div>
  <pre
    appGlossScroll
    class="tw-m-0 tw-text-xs tw-font-mono tw-max-h-[min(60vh,36rem)] tw-overflow-auto tw-p-3 tw-bg-neutral-900 tw-text-dt-text-disabled tw-rounded tw-whitespace-pre-wrap tw-break-words gs-dark"
    >{{ itemJson() }}</pre
  >
</div>
<div mat-dialog-actions class="tw-flex tw-justify-end tw-gap-2">
  <button mat-button mat-dialog-close type="button">Close</button>
</div>
